/**
 * Canonical Joint Keys — adapter-agnostic anatomical names.
 * See docs/architecture-spec.md §4.3.
 */

export const CANONICAL_JOINT_KEYS = [
  'head',
  'leftEye',
  'rightEye',
  'leftEar',
  'rightEar',
  'mouth',
  'neckBase',
  'leftShoulder',
  'rightShoulder',
  'leftElbow',
  'rightElbow',
  'leftWrist',
  'rightWrist',
  'leftHand',
  'rightHand',
  'spineUpper',
  'spineMid',
  'spineLower',
  'pelvis',
  'leftHip',
  'rightHip',
  'leftKnee',
  'rightKnee',
  'leftAnkle',
  'rightAnkle',
  'leftHeel',
  'rightHeel',
  'leftToe',
  'rightToe',
] as const;

export type CanonicalJointKey = (typeof CANONICAL_JOINT_KEYS)[number];

/** PII-classified canonical joints. Adapters must omit these when the
 *  host opts out via QualityProfile.pii.faceLandmarks = 'exclude'. */
export const FACE_JOINT_KEYS: readonly CanonicalJointKey[] = [
  'head',
  'leftEye',
  'rightEye',
  'leftEar',
  'rightEar',
  'mouth',
];
